import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/views/base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.ResponseFormFreeText = class ResponseFormFreeText extends AssessmentBuilder.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return (this.nextQuestionView = new AssessmentBuilder.Views.ResponseFormNextQuestionSelect({
      model: this.model,
      selectItems: this.selectItems,
    }).render());
  }

  render() {
    this.$el.html(this.template(Object.assign({}, this.model.attributes)));
    this.$("attribute.next_question").html(this.nextQuestionView.el);
    return this;
  }
};
AssessmentBuilder.Views.ResponseFormFreeText.prototype.tagName = "free-text-response-form";
AssessmentBuilder.Views.ResponseFormFreeText.prototype.template = _.template(
  AssessmentBuilder.Templates.Response.Form.free_text,
);
